import { render, staticRenderFns } from "./UpdateIssue.vue?vue&type=template&id=0938ff47&"
import script from "./UpdateIssue.vue?vue&type=script&lang=js&"
export * from "./UpdateIssue.vue?vue&type=script&lang=js&"
import style0 from "./UpdateIssue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports